import {createSelector} from 'reselect';
import props from '../../../props';

export default createSelector(
    props.tasks.tasks.daily.facebook,
    (task) => {
        return {
            task
        }
    }
)